import React from 'react'
import Header from '../components/Header'
import { SinglePlaylist } from '../components/SinglePlaylistPage'
import { SingleVedio } from '../components/SingleVedio'

export const SinglePlaylistPage = () => {
  return (
      <>
        <Header/>
        <SinglePlaylist/>
    </>
  )
}
